export const CompanionAnimals = [
    {
        type: "Companion Animals",
        name: "⭐️ EVERYTHING YOU NEED TO KNOW",
        category: "guide",
        author: "",
        description:
            "Learn more about vegan pets in this ultimate all you can read guide.",
        link: "https://www.reddit.com/r/veganpets/wiki/faq#wiki_vegan_pet_food_brands",
        "": "",
    },
    {
        type: "Companion Animals",
        name: "Are Pets Vegan? Dog-matic Vegans Say No | +What Pets Can You Feed Vegan?!)",
        category: "video",
        author: "",
        description:
            "Is the concept of pet ownership or companionship vegan? Can cats and dogs be fed a vegan diet? What are the risks",
        link: "https://www.youtube.com/watch?v=Kpa4w5l66Hg",
        "": "",
    },
    {
        type: "Companion Animals",
        name: "Is It Safe To Feed Your House Cat A Vegan Diet?",
        category: "article",
        author: "",
        description:
            "Vegan cats cause a lot of controversy. In fact, putting any omnivorous or carnivorous animal on a vegan diet incenses vegans and non-vegans alike.",
        link: "https://academy.plantbasednews.org/blog/cat-vegan-diet",
        "": "",
    },
    {
        type: "Companion Animals",
        name: "The Facts About Vegan Cats and Dogs",
        category: "website",
        author: "",
        description:
            "Detailed summaries of the health and nutritional implications of both meat-based and vegan cat and dog diets",
        link: "http://petfoodinnovation.info/",
        "": "",
    },
    {
        type: "Companion Animals",
        name: "Vegetarian versus Meat-Based Diets for Companion Animals",
        category: "study",
        author: "",
        description:
            "2016 published and peer reviewed paper discussing the effectiveness and safety of a plant-based and non flesh diets for dogs and cats:",
        link: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5035952/",
        "": "",
    },
    {
        type: "Companion Animals",
        name: "How do Plant-Based Diets for Pets Stack Up Against Meat-Based Diets?",
        category: "article",
        author: "",
        description:
            "A new paper explores the nutritional adequacy of vegetarian diets for pets and how they compare to meat-based diets.",
        link: "https://www.dvm360.com/view/how-do-plant-based-diets-for-pets-stack-up-against-meat-based-diets",
        "": "",
    },
    {
        type: "Companion Animals",
        name: "Vegan cats live long and healthy lives - preliminary study results",
        category: "article",
        author: "",
        description:
            "Ontario Veterinary College preliminary study (most recent study currently)",
        link: "https://vecado.ca/blogs/news/vegan-cats-live-long-and-healthy-lives-according-to-new-study?fbclid=IwAR2NadNaFlsrs6PQLV2FG3i6BtFRCXLrFsIrxJQElN_ze2ZipgWDf4cwQdA",
        "": "",
    },
    {
        type: "Companion Animals",
        name: "Dr. Andrew Knight introduces himself and his work with cats and dogs",
        category: "video",
        author: "",
        description:
            "Vegusto interview with Dr. Andrew Knight regarding the many aspects of maintaining cats and dogs on a vegetarian or vegan diet.",
        link: "https://www.youtube.com/watch?v=K9m_liQppxQ&list=PLxKqgL2UcLaTWSJpyOMR79od2DWkaeAWp",
        "": "",
    },
    {
        type: "Companion Animals",
        name: "Vegan Cats 101: nutrients, not ingredients is what really matter",
        category: "article",
        author: "",
        description:
            "When thinking of cats we think carnivores, hunters and sharp instincts. No wonder then that putting the two words - vegan and cats - in the same sentence has been the subject of many heated debates.",
        link: "https://vecado.ca/pages/cats101",
        "": "",
    },
    {
        type: "Companion Animals",
        name: "Vegan Dogs 101: plant-based nutrition for dog",
        category: "article",
        author: "",
        description:
            "A common concern about plant-based food for dogs is whether it is “natural”. If dogs evolved from wolves, and wolves preyed on other animals, shouldn't dogs also eat flesh?",
        link: "https://vecado.ca/pages/dogs101",
        "": "",
    },
    {
        type: "Companion Animals",
        name: "Vegan Dog Nutrition",
        category: "fb group",
        author: "",
        description:
            "This group is for vegans to share their experience of feeding vegan food to their CANINE COMPANIONS, either homemade, bought, or a combination.",
        link: "https://www.facebook.com/groups/398407553536988",
        "": "",
    },
    {
        type: "Companion Animals",
        name: "Vegan Cats Group",
        category: "fb group",
        author: "",
        description:
            "This group is designed to promote the feeding of ethical, properly balanced, and nutritionally complete diets to domesticated cats.",
        link: "https://www.facebook.com/groups/126322004672",
        "": "",
    },
    {
        type: "Companion Animals",
        name: "Vegan Pets Community",
        category: "subreddit",
        author: "",
        description: "Share photos, research, news, or thoughts about vegan pets.",
        link: "https://www.reddit.com/r/veganpets",
        "": "",
    },
    {
        type: "Companion Animals",
        name: "Vegan Pet Food Brands",
        category: "list",
        author: "",
        description: "A list of vegan pet food brands",
        link: "https://www.reddit.com/r/veganpets/wiki/faq#wiki_vegan_pet_food_brands",
        "": "",
    },
    {
        type: "Companion Animals",
        name: "Why don't vegans buy pets?",
        category: "video",
        author: "",
        description: "Reasons why vegans don't own pets",
        link: "https://www.youtube.com/watch?v=g8Thb4E8_HYY",
        "": "",
    },
    {
        type: "Companion Animals",
        name: "These Companies Make Vegan Dog Food",
        category: "article",
        author: "",
        description: "",
        link: "https://www.kindlygeek.com/these-companies-make-vegan-dog-food/",
        "": "",
    },
    {
        type: "Companion Animals",
        name: "The Best Vegan Dog Foods Compared and Priced",
        category: "",
        author: "",
        description: "",
        link: "https://www.kindlygeek.com/best-vegan-dog-foods-compared-and-priced/",
        "": "",
    },
]
